import React from 'react';
import { IconProps } from '.';

const SvgColoredZDelivery = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#A89FFF'
        d='M7.99 8.5H5.707c-1.083 0-2.099.464-2.747 1.242l-2.738 3.3a.743.743 0 0 0-.077.148l-.068.114a.924.924 0 0 0-.077.358v4.306C0 18.536.513 19 1.141 19H8V8.5h-.01Z'
      />
      <path fill='#604EDF' d='M6.5 12.5H3l1.236-1.602c.192-.254.497-.398.827-.398H6.5v2Z' />
      <path
        fill='#7463F2'
        d='M8 19h14.934c.587 0 1.066-.488 1.066-1.087V5.76C24 3.955 22.564 2.5 20.804 2.5h-9.608C9.426 2.5 8 3.964 8 5.76V19Z'
      />
      <path fill='#fff' d='M13.619 6v1.683h2.037L13.5 13.2h4.681v-1.686H16.16L18.3 6h-4.681Z' />
      <path
        fill='#8F82FF'
        d='M6.5 22.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM17.5 22.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z'
      />
      <path
        fill='#C8C1FF'
        d='M6.5 20.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17.5 20.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z'
      />
    </svg>
  );
};

export default SvgColoredZDelivery;
